import React from "react";
import {
  faFacebookSquare,
  faGithubSquare,
  faInstagramSquare,
  faLinkedin,
  faTwitterSquare,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { NavLink } from "react-bootstrap";
// import { Container } from "react-bootstrap";
// import TextLoop from "react-text-loop";
import "./Home.css";
import "../About/About.css"

const Home = () => {
  return (
    // <Container className="m-auto p-0">

    // <div className="home">
    //   <div className="my-auto text-center text-md-center text-lg-start">
    //     <h1 className="title">Hi, I'm Hasibul Hasan.</h1>
    //     <h3 className="secondary-title">
    //       I Am A{" "}
    //       <TextLoop>
    //         <span>Full Stack Developer</span>
    //         <span>MERN Stack Developer</span>
    //       </TextLoop>
    //     </h3>
    //     <a
    //       className="resume"
    //       href="https://drive.google.com/file/d/1JU4k03gpe9LoKFhxuIx3GtNV13s8dtrI/view"
    //       target="_blank"
    //       rel="noreferrer"
    //     >
    //       My Resume
    //     </a>
    //   </div>
    //   <div className="my-auto text-center text-lg-end">
    //     <img src="https://i.imgur.com/QMh8NbC.png" className="image" alt="" />
    //   </div>
    // </div>
    // </Container>

    <div className="construction text-center">
      <div className="construction-container">
        <div className="secondary mb-2">
          <div className="bar"></div>
          <p className="secondary-title">MY NEW WEBSITE</p>
          <div className="bar"></div>
        </div>

        {/* <div className="main mb-4">
        </div> */}
          <p className="main-title">Under Construction</p>

        <div className="construction-bar-container mx-auto mt-4">
          <div className="progress mx-auto">
            <div className="progress-value construction-bar"></div>
          </div>
          <div className="mt-2">
            <p className="completed text-white">10% Completed!</p>
          </div>
        </div>

        <div className="big-bar mt-5"></div>

        <p className="contact-title text-white mt-5 fs-2 fw-bold">YOU CAN FIND ME</p>

        <div className="d-md-flex justify-content-center gap-5 mt-3">
          <NavLink
            className="p-0"
            href="https://github.com/hshanto707"
            target="_blank"
          >
            <FontAwesomeIcon className="social mt-2 mt-md-0" icon={faGithubSquare} />
          </NavLink>
          <NavLink
            className="p-0"
            href="https://www.linkedin.com/in/hshanto707/"
            target="_blank"
          >
            <FontAwesomeIcon className="social mt-2 mt-md-0" icon={faLinkedin} />
          </NavLink>
          <NavLink
            className="p-0"
            href="https://www.facebook.com/hshanto707/"
            target="_blank"
          >
            <FontAwesomeIcon className="social mt-2 mt-md-0" icon={faFacebookSquare} />
          </NavLink>
          <NavLink
            className="p-0"
            href="https://twitter.com/hshanto707"
            target="_blank"
          >
            <FontAwesomeIcon className="social mt-2 mt-md-0" icon={faTwitterSquare} />
          </NavLink>
          <NavLink
            className="p-0"
            href="https://www.instagram.com/hshanto707/"
            target="_blank"
          >
            <FontAwesomeIcon className="social mt-2 mt-md-0" icon={faInstagramSquare} />
          </NavLink>
        </div>
      </div>

      <div class="overlay"></div>
    </div>
  );
};

export default Home;
